import React from "react";
import { LinkedinOutlined, FacebookOutlined, InstagramOutlined, PhoneOutlined, MailOutlined } from "@ant-design/icons";
import { Row, Col, Typography, Card } from "antd";
import BindeleddetLocationMap from "components/BindeleddetLocationMap/BindeleddetLocationMap";
import FAQcollapse from "./FAQcollapse/FAQcollapse";

const { Title, Paragraph } = Typography;

const KDContactUs = () => {
  return (
    <Row style={{ justifyContent: "center", padding: "2em 5%" }} gutter={[40, 20]}>
      <Col lg={16} xs={24}>
        <Title level={3}>Ofte stilte spørsmål</Title>
        <Card>
          <FAQcollapse />
        </Card>
      </Col>
      <Col lg={8} xs={24}>
        <Title level={3}>Kontaktinformasjon</Title>
        <Row gutter={[20, 20]}>
          <Col lg={24} md={12} sm={24}>
            <Card>
              <Paragraph>
                <Title level={5}>Kontakt oss</Title>
                <PhoneOutlined /> <a href="tel:+4795365352">+47 953 65 352</a>
                <br /> <MailOutlined /> <a href="mailto:kd@bindeleddet.no">kd@bindeleddet.no</a>
                <br />
                <br />
                <Title level={5}>Adresse</Title>
                Kolbjørn Hejes vei 1E <br />
                7034 Trondheim, Norge <br />
                <br />
                <Title level={5}>Tekniske problemer?</Title>
                For spørsmål vedrørende nettsidene eller ved tekniske problemer, kontakt:{" "}
                <a href="mailto:it@bindeleddet.no">it@bindeleddet.no</a>
                <br />
                <br />
                <br />
                <a href="https://www.facebook.com/bindeleddet.ntnu/?fref=ts">
                  <FacebookOutlined style={{ fontSize: "2em" }} />
                </a>
                <a href="https://www.instagram.com/bindeleddet/">
                  <InstagramOutlined style={{ fontSize: "2em", paddingLeft: "5%" }} />
                </a>
                <a href="https://www.linkedin.com/company/bindeleddet-ntnu">
                  <LinkedinOutlined style={{ fontSize: "2em", paddingLeft: "5%" }} />
                </a>
              </Paragraph>
            </Card>
          </Col>
          <Col lg={24} md={12} sm={24} xs={24}>
            <Card>
              <BindeleddetLocationMap />
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default KDContactUs;
